module.exports = __webpack_public_path__ + "static/media/cert_87.53f5c270.jpg";